import { AriType } from "../updateForm";

export interface DailySet {
  startDate: string;
  endDate: string;
  value: number | boolean | string;
}

export enum ValueTypes {
  rate = "rate",
  availability = "availability",
  closed = "closed",
  closeToArrival = "closeToArrival",
  closeToDeparture = "closeToDeparture",
  minStay = "minStay",
  maxStay = "maxStay",
  minNotice = "minNotice",
  maxNotice = "maxNotice"
}

export interface ARIValues {
  ticker: string;
  dailySet: DailySet[];
  valueType: ValueTypes;
  type: AriType;
  name?: string;
  parentTicker?: string;
  isChild?: boolean;
  formula?: string;
}

export interface HandleInputChangeRequest {
  ticker: string;
  valueType: ValueTypes;
  date: Date;
  value: number | boolean;
  type: AriType;
}

export interface BackofficeARIDTO {
  [ticker: string]: {
    [key in ValueTypes]: {
      dailySet: DailySet[]
    }
  };
}

export interface UpdatedARIValue {
  [ticker: string]: {
    [type: string]: {
      [date: string]: number | boolean;
    };
  };
}
